module.exports = __webpack_public_path__ + "static/media/trait-icons-self-confidence.4f219e3b.svg";